// extracted by mini-css-extract-plugin
export default {"assetIcon":"IconField__assetIcon-cJDpn","assetIconArea":"IconField__assetIconArea-y4WdH","assetIconTitle":"IconField__assetIconTitle-KRZUJ","uploader":"IconField__uploader-H73_r"};